import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-16 sm:py-20 lg:py-28 bg-background">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-red-700">Questions, Answered</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-950">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-${i}`}
              className="rounded-xl bg-white border border-slate-200 px-5 shadow-sm"
            >
              <AccordionTrigger className="text-left font-display font-semibold text-base sm:text-lg text-slate-900 hover:text-red-700 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
